import { motion } from 'framer-motion';
import { LiquidCard } from '../ui/Card';

const testimonials = [
  {
    name: 'Lucas M.',
    avatar: 'https://api.dicebear.com/9.x/notionists/svg?seed=Lucas&backgroundColor=1a0a0e',
    product: 'Plano OVER',
    text: 'Melhor investimento que fiz. O conteúdo é absurdo, a biblioteca exclusiva não tem fim e o chat com as modelos é viciante. Vale cada centavo.',
    rating: 5,
  },
  {
    name: 'Fernanda S.',
    avatar: 'https://api.dicebear.com/9.x/notionists/svg?seed=Fernanda&backgroundColor=1a0a0e',
    product: 'Troca de Casais',
    text: 'Meu marido e eu estávamos procurando algo assim há muito tempo. A plataforma é discreta, os casais são verificados e a experiência foi inesquecível.',
    rating: 5,
  },
  {
    name: 'Rafael T.',
    avatar: 'https://api.dicebear.com/9.x/notionists/svg?seed=Rafael&backgroundColor=1a0a0e',
    product: 'Bonde dos Cornos',
    text: 'A comunidade é super ativa e o conteúdo ao vivo é diferente de tudo que já vi. Grupo VIP de verdade, sem enrolação.',
    rating: 5,
  },
  {
    name: 'Camila R.',
    avatar: 'https://api.dicebear.com/9.x/notionists/svg?seed=Camila&backgroundColor=1a0a0e',
    product: 'Ghotrix',
    text: 'Finalmente achei um canal dedicado ao estilo que eu amo. Atualizado todo dia, qualidade HD e as modelos são incríveis.',
    rating: 5,
  },
  {
    name: 'Bruno K.',
    avatar: 'https://api.dicebear.com/9.x/notionists/svg?seed=Bruno&backgroundColor=1a0a0e',
    product: 'Chamadas Ao Vivo',
    text: 'A chamada foi privada, a modelo super profissional e a qualidade de vídeo surpreendeu. Já agendei a próxima.',
    rating: 5,
  },
  {
    name: 'Thiago V.',
    avatar: 'https://api.dicebear.com/9.x/notionists/svg?seed=Thiago&backgroundColor=1a0a0e',
    product: 'BR PLUS',
    text: 'Conteúdo nacional de qualidade, curado de verdade. Nada de lixo, só o melhor. Assino há 3 meses e não cancelo nunca.',
    rating: 5,
  },
];

export const Testimonials = () => {
  return (
    <section className="relative py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-white">O que dizem </span>
            <span className="text-accent-gold">nossos clientes</span>
          </h2>
          <div className="h-px w-24 bg-gradient-to-r from-transparent via-accent-gold to-transparent mx-auto" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 * index }}
            >
              <LiquidCard className="p-6 h-full flex flex-col gap-4">
                {/* Stars */}
                <div className="flex gap-1">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <svg key={i} className="w-4 h-4 text-accent-gold" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>

                {/* Badge produto */}
                <span className="self-start text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full border border-accent-gold/30 text-accent-gold/80 font-semibold">
                  {testimonial.product}
                </span>

                {/* Quote */}
                <p className="text-white/70 leading-relaxed flex-1 italic text-sm">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 mt-auto pt-4 border-t border-white/10">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-10 h-10 rounded-full bg-primary-900 object-cover flex-shrink-0"
                  />
                  <span className="text-white/80 font-medium text-sm">{testimonial.name}</span>
                </div>
              </LiquidCard>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
